import React, { useEffect, useState, useContext } from 'react';
import {
  Button,
  CircularProgress,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  LinearProgress,
  List,
  Typography,
  ListItem,
  ListItemText,
  Snackbar,
  SnackbarContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './InspectorOrderReview.styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import blueSkyVueLogo from '../../assets/images/bluesky-vue-logo.png';
import { AppContext } from '../../AppContext';
import {
  InspectorOrderReviewContext,
  InspectorOrderReviewContextProvider,
  UPDATE_ORDER,
  UPDATE_ORDER_FORMS,
  UPDATE_ORDER_INFO,
  UPDATE_INSPECTION_STEPS,
  UPDATE_ORDER_DATA,
  upsertOrderForms,
  removeOrderForm,
} from './InspectorOrderReviewContext/InspectorOrderReviewContext';
import classnames from 'classnames';
import ListIcon from '@material-ui/icons/List';
import FieldRepInspectionForm, { ColoredInfoIcon } from '../Orders/FieldRepInspectionForm';
import ImageCarousel from '../ImageCarousel';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import InspectorWalkaround from './InspectorWalkaround/InspectorWalkaround';
import InspectorReviewScreen from './InspectorReview';
import SelfInspectIntroScreen from './SelfInspectIntro';

// SERVICES
import {
  // createOrderPDFReport,
  // completeOrderReview,
  // getData,
  // getOrderById,
  getInspectorOrder,
  getInspectorOrderForms,
  getZippedImages,
  saveForm,
  getInspectorOrderTicket,
  getData,
  submitOrder,
  createFormHeaderTemplate,
  removeOrderFormHeaderById,
  PostRCTAnswers,
  unstashOrder,
} from '../../services';
import { useDrag } from 'react-dnd';
import { DND_TYPES } from '../../enums';
import cn from 'classnames';
import PhotoUploadDialog from '../PhotoUploadDialog/PhotoUploadDialog';
import OrderInfoFormDefinition from '../QaOrderReview/OrderInfoFormDefinition';
import { isSmallDevice } from '../../helpers';
import { ReportAttachments } from '../ReportAttachments';

// import { OrderReviewService } from "../../../services/OrderReviewService";

const propTypes = {
  // classes: PropTypes.object.isRequired,
  // id: PropTypes.string.isRequired,
  // options: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const stepComponents = {
  selfInspectIntro: SelfInspectIntroScreen,

  // conditionForm: GeneralInfoIntro,
  // liabilityForm: GeneralInfoIntro,
  walkaroundExteriorScreen: InspectorWalkaround,
  walkaroundInteriorScreen: InspectorWalkaround,
  // interviewForm: GeneralInfoIntro,
  // interviewIntro: InterviewIntro,
  // generalInfoIntro: GeneralInfoIntro,
  // inspectionOrderData: InspectionOrderData,
  inspectionForm: FieldRepInspectionForm,
  review: InspectorReviewScreen,
};

const DndItem = ({ children, itemProps }) => {
  const {
    state: { imageDictionary },
  } = useContext(InspectorOrderReviewContext);

  const { formAnswerImageId, formFieldRepAnswerImageId, ...imageDef } =
    imageDictionary[itemProps.formFieldRepImageId] || {};

  const [{ isDragging }, dragRef] = useDrag({
    item: { type: DND_TYPES.IMAGE, ...imageDef, ...itemProps },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={dragRef}
      className={cn(
        'flex-1',
        // , 'col-center-center'
      )}
      style={{
        // minWidth: '33%',
        cursor: isDragging ? 'grabbing' : 'default',
      }}
    >
      {children}
    </div>
  );
};

const tooltipFormatter = (image, index) => {
  return image.questions && image.questions.length ? (
    <div>
      <div style={{ marginBottom: 10 }}>Belongs to:</div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {image.questions.map((q, qIdx) => (
          <span key={qIdx}>{q.questionLabel}</span>
        ))}
      </div>
    </div>
  ) : (
    <div>This photo is not attached to anything</div>
  );
};

const snackbarActions = {
  DASHBOARD: 'DASHBOARD',
  RELOAD: 'RELOAD',
};

const InspectorOrderReview = withStyles(styles)(({ classes, options, history, match }) => {
  const { orderLineId } = match.params;
  const {
    state: { sidebarIsOpen, roles },
    dispatch,
  } = useContext(AppContext);
  const {
    state: {
      order,
      orderData,
      orderForms,
      orderInfo,
      imageDictionary,
      imagesWithQuestions,
      inspectionSteps,
      isSelfInspect,
    },
    dispatch: reviewDispatch,
  } = useContext(InspectorOrderReviewContext);

  /**
   * STATE
   */
  const [isLoading, setIsLoading] = useState(true);

  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloadingImages, setIsDownloadingImages] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [dirtyTree, setDirtyTree] = useState({});
  const [snackbarAction, setSnackbarAction] = useState(snackbarActions.DASHBOARD);
  const [showReturnToDashboardSnackbar, setShowReturnToDashboardSnackbar] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);
  const [photoUploadDialogVisible, setPhotoUploadDialogVisible] = useState(false);

  const [showConfirmFormHeaderAdditionDialog, setShowConfirmFormHeaderAdditionDialog] = useState(false);
  const [showConfirmFormHeaderRemovalDialog, setShowConfirmFormHeaderRemovalDialog] = useState(false);
  const [showSendBackToAppDialog, setShowSendBackToAppDialog] = useState(false);
  const [showInstructionsDialog, setShowInstructionsDialog] = useState(false);

  const [unstashLoading, setUnstashLoading] = useState(false);

  const [formHeaderToAdd, setFormHeaderToAdd] = useState(null);
  const [orderFormHeaderToRemove, setOrderFormHeaderToRemove] = useState(null);
  const [addFormHeaderCb, setAddFormHeaderCb] = useState(null);

  /**
   * COMPUTED
   */

  /**
   * FUNCTIONS
   */
  const toggleSidebar = open => {
    dispatch({
      type: 'SET_SIDEBAR_IS_OPEN',
      sidebarIsOpen: open,
    });
  };

  const goToStep = label => {
    setCurrentStep(inspectionSteps.findIndex(is => is.label == label));

    // scroll to top of each new page so it doesn't start in the middle
    const scrollableBody = document.getElementById('inspector-order-review-scrollable-body');
    scrollableBody.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  /**
   * @desc move to a different step (either forwards or backwards)
   * @param {*} amount { -1 or +1 }
   */
  const changeStep = (amount = 1) => {
    setCurrentStep(currentStep + amount);
  };

  const submitOrderAsync = async () => {
    try {
      setIsSubmitting(true);

      // check if there are any changes that need saved
      if (Object.keys(dirtyTree).length) {
        const error = await saveFormAsync(false);

        if (error) {
          throw error;
        }
      }

      const result = await submitOrder(orderLineId);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Order submitted successfully!',
        },
      });
      history.push('/');
    } catch (error) {
      console.log(error);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: error.message || 'There was an error submitting the order...',
        },
      });
    }

    setIsSubmitting(false);
  };

  const submitRCTOrderAsync = async event => {
    try {
      setIsSubmitting(true);

      var formKeyValues = event.nativeEvent.currentTarget.all;
      var orderLineID = order.orderLineId;

      const fields = Array.prototype.slice
        .call(formKeyValues)
        .filter(el => el.name)
        .reduce(
          (form, el) => ({
            ...form,
            [el.name]: el.value,
          }),
          {},
        );

      var arFormFields = {};

      var tifOptions = Object.keys(fields).forEach(function(key) {
        if (fields[key] != undefined) {
          var test = 0;
          var keyParts = key.split('_');
          var cntrlType = keyParts[2];

          var test = keyParts[1];

          if (cntrlType == 'checkbox') {
            var cntrl = document.getElementsByName(key)[0];
            if (cntrl.checked) {
              arFormFields[key] = fields[key];
            }
          } else if (cntrlType == 'radio') {
            var radios = document.getElementsByName(key);

            for (var i = 0, length = radios.length; i < length; i++) {
              if (radios[i].checked) {
                var ctrlID = radios[i].value;
                arFormFields[key] = ctrlID;

                // only one radio can be logically checked, don't check the rest
                break;
              }
            }
          } else {
            arFormFields[key] = fields[key];
          }
        }
      });

      var fieldsSaved = JSON.stringify(arFormFields);

      const error = await PostRCTAnswers(fieldsSaved, orderLineID);

      // check if there are any changes that need saved
      if (Object.keys(dirtyTree).length) {
        const error = await saveFormAsync(false);

        if (error) {
          throw error;
        }
      }

      const result = await submitOrder(orderLineId);
      // await new Promise(resolve => setTimeout(resolve, 1500));

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Order submitted successfully!',
        },
      });
      history.push('/');
    } catch (error) {
      console.log(error);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: error.message || 'There was an error submitting the order...',
        },
      });
    }

    setIsSubmitting(false);
  };

  const returnToDashboard = () => {
    toggleSidebar(true);
    return history.push('/'); // this is the homepage (and orders grid) for inspectors
  };

  const handleSnackbarContinue = () => {
    /**
     * TODO.babyjay: add the refresh watcher to alert the user of unsaved changes if the page is being refreshed
     */
    // if (snackbarAction === snackbarActions.DASHBOARD) {}
    returnToDashboard();

    // if (snackbarAction === snackbarActions.RELOAD) {
    //   window.location.reload();
    // }
  };

  const requestAbortPage = action => {
    // setSnackbarAction(action);

    // if there are changes, tell the user that the changes will be lost
    if (Object.keys(dirtyTree).length) {
      setShowReturnToDashboardSnackbar(true);
      return;
    }

    returnToDashboard();

    // skip the snackbar and act like they hit CONTINUE on the snackbar
    // handleSnackbarContinue();
    // action === snackbarActions.DASHBOARD && returnToDashboard();
    // action === snackbarActions.RELOAD && window.location.reload();
  };

  /**
   * @func saveRCTFormAsync
   * @func saveFormAsync
   * @desc saves all forms in order review
   * @param {*} showSnackbars
   * @returns error (if applicable)
   */
  const saveFormAsync = async (showSnackbars = true) => {
    try {
      setIsSaving(true);
      const res = await saveForm(orderForms, order.orderLineId);

      showSnackbars &&
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Form saved successfully',
          },
        });

      // if successful, reset errors and dirty tree data
      setDirtyTree({});
      setIsSaving(false);

      return null;
    } catch (error) {
      showSnackbars &&
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: error.message || 'There was an error saving the form',
          },
        });
      setIsSaving(false);

      return error;
    }
  };

  const saveRCTFormAsync = async (event, showSnackbars = true) => {
    try {
      setIsSaving(true);
      // const res = await PostRCTAnswers(orderForms, order.orderLineId);

      var formKeyValues = event.nativeEvent.currentTarget.all;
      var orderLineID = order.orderLineId;

      const fields = Array.prototype.slice
        .call(formKeyValues)
        .filter(el => el.name)
        .reduce(
          (form, el) => ({
            ...form,
            [el.name]: el.value,
          }),
          {},
        );

      var arFormFields = {};

      var tifOptions = Object.keys(fields).forEach(function(key) {
        if (fields[key] != undefined) {
          var test = 0;
          var keyParts = key.split('_');
          var cntrlType = keyParts[2];

          var test = keyParts[1];

          if (cntrlType == 'checkbox') {
            var cntrl = document.getElementsByName(key)[0];
            if (cntrl.checked) {
              arFormFields[key] = fields[key];
            }
          } else if (cntrlType == 'radio') {
            var radios = document.getElementsByName(key);

            for (var i = 0, length = radios.length; i < length; i++) {
              if (radios[i].checked) {
                var ctrlID = radios[i].value;
                arFormFields[key] = ctrlID;

                // only one radio can be logically checked, don't check the rest
                break;
              }
            }
          } else {
            arFormFields[key] = fields[key];
          }
        }
      });

      var fieldsSaved = JSON.stringify(arFormFields);

      PostRCTAnswers(fieldsSaved, orderLineID);

      showSnackbars &&
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Form saved successfully',
          },
        });

      // if successful, reset errors and dirty tree data
      setDirtyTree({});
      setIsSaving(false);

      return null;
    } catch (error) {
      showSnackbars &&
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: error.message || 'There was an error saving the form',
          },
        });
      setIsSaving(false);

      return error;
    }
  };

  const requestRemoveOrderFormHeader = orderForm => {
    setShowConfirmFormHeaderRemovalDialog(true);
    setOrderFormHeaderToRemove(orderForm);
  };

  const removeOrderFormHeader = async () => {
    try {
      const result = await removeOrderFormHeaderById(orderLineId, orderFormHeaderToRemove.orderFormHeaderId);

      // upsert this form
      const updatedOrderForms = removeOrderForm(orderForms, orderFormHeaderToRemove);

      // update in state (configureSteps will be called)
      reviewDispatch({
        type: UPDATE_ORDER_FORMS,
        orderForms: updatedOrderForms,
      });

      setShowConfirmFormHeaderRemovalDialog(false);
    } catch (error) {
      console.log(error);
    }
  };

  const requestAddFormHeader = (formHeaderId, onConfirmCb) => {
    setShowConfirmFormHeaderAdditionDialog(true);
    setAddFormHeaderCb(() => onConfirmCb);
    setFormHeaderToAdd(formHeaderId);
  };

  const addFormHeader = async () => {
    const formHeaderTemplate = await createFormHeaderTemplate(orderLineId, { formHeaderId: formHeaderToAdd });

    addFormHeaderCb && addFormHeaderCb();

    setAddFormHeaderCb(null);
    setShowConfirmFormHeaderAdditionDialog(false);

    // if no formHeader was created (one already existed), then just ignore it
    if (!formHeaderTemplate) {
      return;
    }

    // upsert this form
    const updatedOrderForms = upsertOrderForms(orderForms, formHeaderTemplate);

    // update in state (configureSteps will be called)
    reviewDispatch({
      type: UPDATE_ORDER_FORMS,
      orderForms: updatedOrderForms,
    });

    // this.orderForms.push(formHeaderTemplate);
    // configureSteps(this.orderForms);
  };

  const getHeader = () => {
    if (inspectionSteps[currentStep].hideHeader) {
      return null;
    }
    return (
      <>
        {/* <div
         // className={cn('row-between-center', 'flex-1')}
         className='app-header-left'
         style={{
           backgroundColor: 'white',
           borderBottomWidth: 0,
           fontSize: '1.5rem',
           // height: 40,
         }}
       > */}
        <div className={cn('app-header-left')}>
          <div className={cn('row-start-center')}>
            <Typography variant="subtitle1" className={classes.orderTicketNumber} noWrap style={{ textAlign: 'left' }}>
              {isSelfInspect ? (
                <div className={classes.orderNumberLabel}>JMI Self Inspect</div>
              ) : (
                <>
                  <div className={classes.returnToGridLink} onClick={requestAbortPage}>
                    <ChevronLeftIcon
                      style={{
                        height: 20,
                        width: 20,
                      }}
                    />
                    Return to Dashboard
                  </div>
                  <div className={classes.orderNumberLabel}>Order #{orderData.orderLineId}</div>
                </>
              )}
            </Typography>

            {!isSelfInspect && (
              <img
                src={`https://jmistorage.blob.core.windows.net/clientid-${orderData.clientId}/logo.jpg`}
                className={classes.clientLogo}
              />
            )}

            {!isSelfInspect && (
              <>
                <Button
                  variant="contained"
                  className={cn('light-blue-background')}
                  style={{ marginLeft: 15, opacity: 0.4 }}
                >
                  Communication Log
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setShowSendBackToAppDialog(true)}
                  className={cn('light-blue-background')}
                  style={{ marginLeft: 15 }}
                >
                  Return to App
                </Button>
              </>
            )}
          </div>
        </div>
        <div className={cn('row-end-center')}>
          {!!Object.keys(dirtyTree).length && !isSmallDevice() && (
            <div
              className={cn('row-between-center')}
              style={{
                fontSize: 14,
                padding: 8,
                boxShadow: '0 2px 5px #ccc',
                borderRadius: 5,
                marginRight: 15,
                backgroundColor: 'rgba(255, 0, 0, 0.2)',
              }}
            >
              UNSAVED ITEMS:
              <span
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  // background: '#ddd',
                  border: '1px solid #777',
                  padding: 2,
                  marginLeft: 5,
                }}
                className={cn('row-center-center')}
              >
                {Object.keys(dirtyTree).length}
              </span>{' '}
            </div>
          )}

          {orderForms[0].isRCT ? (
            <Button
              // disabled={isSaving || !Object.keys(dirtyTree).length}
              mode="contained"
              style={{
                alignSelf: 'center',
                flexDirection: 'row',
                justifyContent: 'center',
                marginRight: 10,
              }}
              onClick={saveRCTFormAsync}
            >
              {!isSmallDevice() && <span className={cn('mr-10')}>{isSaving ? 'Saving' : 'Save RCT Form'}</span>}
              {isSaving ? (
                <CircularProgress style={{ fill: '#222', color: '#222' }} size={24} />
              ) : (
                <SaveIcon style={{ marginBottom: -8 }} />
              )}
            </Button>
          ) : (
            <Button
              disabled={isSaving || !Object.keys(dirtyTree).length}
              mode="contained"
              style={{
                alignSelf: 'center',
                flexDirection: 'row',
                justifyContent: 'center',

                ...(isSelfInspect
                  ? { minWidth: 0, padding: 0 }
                  : {
                      marginRight: 10,
                    }),
              }}
              onClick={saveFormAsync}
            >
              {!isSmallDevice() && <span className={cn('mr-10')}>{isSaving ? 'Saving' : 'Save Form'}</span>}
              <span>
                {isSaving ? (
                  <CircularProgress style={{ fill: '#777', color: '#222', opacity: 0.4 }} size={24} />
                ) : (
                  <SaveIcon
                    style={{
                      marginBottom: -8,
                      color:
                        isSaving || !Object.keys(dirtyTree).length || !isSelfInspect ? 'inherit' : 'var(--jmi-red)',
                    }}
                  />
                )}
              </span>
            </Button>
          )}

          {!isSelfInspect && (
            <>
              <Button
                disabled={isDownloadingImages}
                mode="contained"
                style={{
                  alignSelf: 'center',
                  // width: 200,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginRight: 10,
                }}
                onClick={downloadImages}
              >
                <span className={cn('mr-10')}>{isDownloadingImages ? 'Downloading' : 'Download'}</span>
                <span>
                  {isDownloadingImages ? (
                    <CircularProgress style={{ fill: '#777', color: '#222', opacity: 0.4 }} size={24} />
                  ) : (
                    <CloudDownloadIcon />
                  )}
                </span>
              </Button>
              <Button
                mode="contained"
                style={{
                  alignSelf: 'center',
                  // width: 200,
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
                onClick={() => setPhotoUploadDialogVisible(true)}
              >
                <span className={cn('mr-10')}>Photo Upload</span>
                <CloudUploadIcon />
              </Button>
            </>
          )}
        </div>
        {/* </div> */}
      </>
    );
  };

  const deepClone = value => {
    let copiedObj = {};

    if (value instanceof Array) {
      copiedObj = value.map(o => deepClone(o));
    } else if (value instanceof Object) {
      for (let key in value) {
        copiedObj[key] = deepClone(value[key]);
      }
    } else {
      copiedObj = value;
    }

    return copiedObj;
  };

  const updateStepData = question => {
    const tempInspectionSteps = inspectionSteps.slice();

    // const tempInspectionSteps = deepClone(inspectionSteps);

    // check if the step is dirty, and make it dirty if it isn't already
    const stepLabel = inspectionSteps[currentStep].label;
    if (!dirtyTree[stepLabel]) {
      setDirtyTree({
        ...dirtyTree,
        [stepLabel]: true,
      });
    }

    tempInspectionSteps[currentStep].stepData.questions = tempInspectionSteps[currentStep].stepData.questions.map(q => {
      return q.questionId === question.questionId ? question : q;
    });

    reviewDispatch({
      type: UPDATE_INSPECTION_STEPS,
      inspectionSteps: tempInspectionSteps,
    });
  };

  const updateStepQuestions = questions => {
    const tempInspectionSteps = inspectionSteps.slice();

    tempInspectionSteps[currentStep].stepData.questions = questions;

    reviewDispatch({
      type: UPDATE_INSPECTION_STEPS,
      inspectionSteps: tempInspectionSteps,
    });
  };

  const removeImageFromQuestion = (question, image, answerTriggerIndex = null) => {
    if (!question.answers || !question.answers[0].formFieldRepAnswerImage) {
      return;
    }

    let answerIndex = 0;

    if (answerTriggerIndex !== null) {
      const answerTrigger = question.answerTriggers[answerTriggerIndex];
      answerIndex = question.answers.findIndex(ans => ans.answerValueId === answerTrigger.answerValueId);
    } else {
      // find the answer index that the image belongs to
      answerIndex = question.answers.findIndex(ans => {
        return (
          ans.formFieldRepAnswerImage &&
          ans.formFieldRepAnswerImage.find(ffri => {
            // TODO.babyjay: refactor all images to use one src or imageUri so you don't need to do a double array search all the time
            const searchUris = [ffri.src, ffri.imageUri].filter(x => x); // filter out null/undefined values
            const removeUris = [image.src, image.imageUri].filter(x => x);

            const isMatch = searchUris.some(search => removeUris.includes(search));
            return isMatch;
          })
        );
      });
    }

    // this should never get hit???
    if (answerIndex === -1) {
      answerIndex = 0;
    }

    // if not, add it and update step data
    question.answers[answerIndex].formFieldRepAnswerImage = question.answers[
      answerIndex
    ].formFieldRepAnswerImage.filter(img => {
      // TODO.babyjay: refactor all images to use one src or imageUri so you don't need to do a double array search all the time
      const searchUris = [img.src, img.imageUri].filter(x => x); // filter out null/undefined values
      const removeUris = [image.src, image.imageUri].filter(x => x);

      const isMatch = searchUris.some(search => removeUris.includes(search));
      return !isMatch; // remove the match
    });

    updateStepData(question);
  };

  const renderStep = () => {
    var currentInspectionStep = inspectionSteps[currentStep];

    const StepComponent = stepComponents[currentInspectionStep.type];

    const stepData = {
      ...currentInspectionStep.stepData,

      requestAddFormHeader,
      // goToNextStep: changeStep,
    };
    return StepComponent ? (
      <StepComponent
        key={currentInspectionStep.label}
        {...inspectionSteps[currentStep]}
        stepData={stepData}
        useSnack={true}
        updateStepData={updateStepData}
        updateStepQuestions={updateStepQuestions}
        removeImageFromQuestion={removeImageFromQuestion}
      />
    ) : (
      'Component Not Found'
    );
  };

  const downloadImages = async () => {
    try {
      setIsDownloadingImages(true);
      await getZippedImages(order.orderLineId);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Pictures zipped',
        },
      });
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Download failed... Please try again',
        },
      });
    }
    setIsDownloadingImages(false);
  };

  const sendOrderBackToApp = async () => {
    try {
      setUnstashLoading(true);
      await unstashOrder(order.orderLineId);

      returnToDashboard();
    } catch (error) {
      //
      console.log('UNSTASH failed... check log for details');
    }
    setUnstashLoading(false);
  };

  // when the confirm dialog is closed, clear the state for the form header to add
  useEffect(() => {
    if (!showConfirmFormHeaderAdditionDialog) {
      setFormHeaderToAdd(null);
    }
  }, [showConfirmFormHeaderAdditionDialog]);

  // when the confirm dialog is closed, clear the state for the order form header to delete
  useEffect(() => {
    if (!showConfirmFormHeaderRemovalDialog) {
      setFormHeaderToAdd(null);
    }
  }, [showConfirmFormHeaderRemovalDialog]);

  useEffect(() => {
    const getDataAsync = async () => {
      setIsLoading(true);
      // const order = await getInspectorOrder(orderLineId);
      // const forms = await getInspectorOrderForms(orderLineId);
      // const ticket = await getInspectorOrderTicket(orderLineId);

      // fetch all at the same time to shorten wait period (all must succeed or the page is going to break anyways)
      const dataPromise = getData(orderLineId);
      const orderPromise = getInspectorOrder(orderLineId);
      const formsPromise = getInspectorOrderForms(orderLineId);
      const ticketPromise = getInspectorOrderTicket(orderLineId);

      const [orderData, order, forms, ticket] = await Promise.all([
        dataPromise,
        orderPromise,
        formsPromise,
        ticketPromise,
      ]);

      setIsLoading(false);

      reviewDispatch({
        type: UPDATE_ORDER,
        order,
      });
      reviewDispatch({
        type: UPDATE_ORDER_DATA,
        orderData,
      });
      reviewDispatch({
        type: UPDATE_ORDER_FORMS,
        orderForms: forms,
      });
      reviewDispatch({
        type: UPDATE_ORDER_INFO,
        orderInfo: ticket,
      });
    };

    getDataAsync();
  }, []);

  window.onpopstate = evt => {
    if (!isSmallDevice()) {
      toggleSidebar(true);
    }
  };

  const getDrawerOpenState = () => {
    const value = localStorage.getItem('drawerOpen');
    if (value === 'false') {
      return false;
    } else {
      return true;
    }
  };

  return isLoading ? (
    <div className={classes.loadingWrapper}>
      <div className={classes.progressWrapper}>
        <Typography className={classes.progressTitle} variant="h4" color="primary">
          Preparing Order...
        </Typography>
        <LinearProgress />
      </div>
    </div>
  ) : order && inspectionSteps && inspectionSteps.length ? (
    <div className="app" style={{ maxHeight: '100vh', maxWidth: '100vw', overflow: 'hidden', zIndex: 1 }}>
      <div className={classnames('app-sidebar', !sidebarIsOpen && 'app-sidebar-closed')}>
        <div className="sidebar-logo-container">
          {isSmallDevice() && (
            <ChevronLeftIcon
              className={classnames('sidebar-toggle-icon')}
              style={{ marginLeft: 0, marginRight: 15 }}
              onClick={() => toggleSidebar(!sidebarIsOpen)}
            />
          )}

          <img src={blueSkyVueLogo} className="sidebar-logo" alt="JMI Bluesky VUE logo" />
        </div>

        <div className={classes.sideNavWrapper} style={{ overflow: 'auto' }}>
          <div>
            <List component="nav" className={classes.sideNavList}>
              {/* <ListItemFormHeaders isCancelled={!!cancelledOrder} /> */}
              {!inspectionSteps.length && <div>Testing</div>}
              {inspectionSteps
                .filter(is => is.menu == true)
                .map((is, isIdx) => {
                  const orderForm = orderForms.find(
                    of => of.formHeaderId === is.formHeaderId && of.orderFormHeaderId === is.orderFormHeaderId,
                  );

                  return (
                    <ListItem
                      key={is.label}
                      button
                      onClick={() => {
                        goToStep(is.label);

                        if (isSelfInspect && isSmallDevice()) {
                          toggleSidebar(false);
                        }
                      }}
                      selected={currentStep === isIdx}
                    >
                      {is.icon && React.cloneElement(is.icon)}

                      <ListItemText
                        primary={is.label}
                        style={{ marginLeft: 15 }}
                        // primary={formHeader.name}
                        primaryTypographyProps={{
                          style: {
                            color: '#fff',
                            fontWeight: currentStep === isIdx ? '600' : '400',
                          },
                        }}
                      />

                      {/* <span>{is.label}</span> */}
                      {dirtyTree[is.label] && (
                        <span
                          style={{
                            width: 7,
                            height: 7,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(150, 150, 150, 0.75)',
                          }}
                        />
                      )}

                      {is.isRemovable && !!orderForm && (
                        <DeleteIcon onClick={() => requestRemoveOrderFormHeader(orderForm)} />
                      )}
                    </ListItem>
                  );
                })}
            </List>
          </div>
          <ExpansionPanel defaultExpanded className={classes.orderInfo}>
            <ExpansionPanelSummary
              expandIcon={<ExpandLessIcon style={{ color: '#fff' }} />}
              aria-controls="order-details"
              id="order-details"
            >
              <Typography variant="subtitle1" className={classes.orderInfoTitle} noWrap>
                Order Details
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ display: 'flex', flexDirection: 'column' }}>
              {orderData &&
                orderData.orderInfoFormDefinitions &&
                orderData.orderInfoFormDefinitions.map((fd, fdIndex) => (
                  <OrderInfoFormDefinition key={fdIndex} formDefinition={fd} />
                ))}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      </div>

      <div
        className="app-main"
        style={{ height: '100vh' }}
        onClick={() => {
          if (isSmallDevice() && sidebarIsOpen) {
            toggleSidebar(false);
          }
        }}
      >
        <div className={'app-header'}>
          <ListIcon
            className={classnames('sidebar-toggle-icon', 'mr-20', !sidebarIsOpen && 'sidebar-toggle-icon-closed')}
            onClick={() => toggleSidebar(!sidebarIsOpen)}
          />

          {/* <div className={classnames('row-start-center', 'flex-1')}>{getHeader()}</div> */}
          {getHeader()}
        </div>

        <div className="app-body" style={{ position: 'relative' }}>
          <div className={classes.contentWrapper}>
            <div
              id="inspector-order-review-scrollable-body"
              style={{
                maxHeight: '100vh',
                overflow: 'auto',
                flex: 1,
                // marginBottom: '0.75rem',
                marginBottom: 55, // for action bar
                paddingBottom: 15,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  position: 'sticky',
                  top: 0,
                  background: '#F8F8F8',
                  zIndex: 3,
                }}
              >
                <div
                  style={{
                    fontSize: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',

                    ...(isSelfInspect
                      ? {
                          paddingLeft: 10,
                          paddingRight: 10,
                          paddingBottom: 10,
                          borderBottom: '1px dashed gray',
                          fontWeight: 'bold',
                        }
                      : {}),
                  }}
                >
                  <span>{inspectionSteps[currentStep].label}</span>

                  {isSelfInspect && (
                    <ColoredInfoIcon style={{ fontSize: 24 }} onClick={() => setShowInstructionsDialog(true)} />
                  )}
                </div>

                {!isSelfInspect && (
                  <>
                    <ImageCarousel
                      images={imagesWithQuestions}
                      tooltip={tooltipFormatter}
                      DndItem={DndItem}
                      containerStyle={{
                        border: '2px solid #ccc',
                        // display: 'flex',
                        // alignItems: 'center',
                      }}
                    />

                    {/* show a message if there are no images */}
                    {!imagesWithQuestions ||
                      (!imagesWithQuestions.length && (
                        <div style={{ padding: 20, color: '#777' }}>
                          There are no photos available... Please upload them by clicking the button above
                        </div>
                      ))}
                  </>
                )}
              </div>

              {renderStep()}
            </div>
          </div>

          {/* bottom action panel */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              boxShadow: '1px 6px 17px 0px black',
              background: 'white',
            }}
          >
            <div style={{ padding: 15 }} className={cn('row-between-center')}>
              {/* left side action buttons */}
              <div className={cn('flex-1')}></div>

              {/* center action buttons */}
              <div className={cn('flex-1', 'row-center-center')}>
                <ReportAttachments orderLineId={orderLineId} readonly />
              </div>

              {/* right side action buttons */}
              <div className={cn('flex-1', 'row-end-center')}>
                <div>
                  <Button
                    disabled={!currentStep}
                    onClick={() => changeStep(-1)}
                    style={{
                      backgroundColor: '#315382',
                      color: 'white',
                      marginRight: 15,
                      opacity: !currentStep ? 0.6 : 1,
                    }}
                  >
                    Previous Step
                  </Button>
                  {currentStep < inspectionSteps.length - 1 && (
                    <Button
                      disabled={currentStep === inspectionSteps.length - 1}
                      onClick={() => changeStep(1)}
                      style={{
                        backgroundColor: '#315382',
                        color: 'white',
                        opacity: currentStep === inspectionSteps.length - 1 ? 0.6 : 1,
                      }}
                    >
                      Next Step
                    </Button>
                  )}
                </div>

                {/* {currentStep === inspectionSteps.length - 1 && (
                  <Button
                    disabled={isSubmitting}
                    onClick={submitOrderAsync}
                    style={{
                      backgroundColor: '#315382',
                      color: 'white',
                      opacity: isSubmitting ? 0.5 : 1,
                      width: 130,
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress style={{ fill: '#222', color: 'white' }} size={24} />
                    ) : (
                      <span>Submit Order</span>
                    )}
                  </Button>
                )} */}

                {currentStep === inspectionSteps.length - 1 && !orderForms[0].isRCT && (
                  <Button
                    disabled={isSubmitting}
                    onClick={submitOrderAsync}
                    style={{
                      backgroundColor: '#315382',
                      color: 'white',
                      opacity: isSubmitting ? 0.5 : 1,
                      width: 130,
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress style={{ fill: '#222', color: 'white' }} size={24} />
                    ) : (
                      <span>Submit Order</span>
                    )}
                  </Button>
                )}

                {currentStep === inspectionSteps.length - 1 && orderForms[0].isRCT && (
                  <Button
                    disabled={isSubmitting}
                    onClick={submitRCTOrderAsync}
                    style={{
                      backgroundColor: '#315382',
                      color: 'white',
                      opacity: isSubmitting ? 0.5 : 1,
                      width: 130,
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress style={{ fill: '#222', color: 'white' }} size={24} />
                    ) : (
                      <span>Submit RCT Order</span>
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dialog for confirming that additional questions will be added */}
      <Dialog
        open={showConfirmFormHeaderAdditionDialog}
        onClose={() => setShowConfirmFormHeaderAdditionDialog(false)}
        aria-labelledby="form-dialog-title"
        // disabled={disabled}
      >
        <DialogTitle>Additional Questions</DialogTitle>
        <DialogContent
          dividers
          style={{
            // minWidth: 500,
            // minHeight: 400,
            borderTop: '0.8px solid #ddd',
            borderBottom: '0.8px solid #ddd',
            paddingTop: 20,
            // pointerEvents: disabled ? 'none' : 'auto',
            // opacity: disabled ? 0.5 : 1,
          }}
        >
          Based on this answer, additional questions will become available
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => setShowConfirmFormHeaderAdditionDialog(false)}
            variant="contained"
            className="red-button"
          >
            Cancel
          </Button>
          <Button
            // disabled={isSubmitting}
            onClick={addFormHeader}
            variant="contained"
            className="blue-button"
          >
            Ok, add them
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing confirmation of an order form header removal */}
      <Dialog
        open={showConfirmFormHeaderRemovalDialog}
        onClose={() => setShowConfirmFormHeaderRemovalDialog(false)}
        aria-labelledby="form-dialog-title"
        // disabled={disabled}
      >
        <DialogTitle>Remove Questions?</DialogTitle>
        <DialogContent
          dividers
          style={{
            // minWidth: 500,
            // minHeight: 400,
            borderTop: '0.8px solid #ddd',
            borderBottom: '0.8px solid #ddd',
            paddingTop: 20,
            // pointerEvents: disabled ? 'none' : 'auto',
            // opacity: disabled ? 0.5 : 1,
          }}
        >
          Are you sure you want to remove this form and all of its questions from this order? This is a destructive
          action and data cannot be recovered.
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => setShowConfirmFormHeaderRemovalDialog(false)}
            variant="contained"
            color="secondary"
            style={{ color: 'white' }}
          >
            No
          </Button>
          <Button
            // disabled={isSubmitting}
            onClick={removeOrderFormHeader}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for confirming an order will be sent back to the mobile app */}
      <Dialog
        open={showSendBackToAppDialog}
        onClose={() => setShowSendBackToAppDialog(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle style={{ textAlign: 'center' }}>
          Are you sure you want to send this order back to your mobile app?
        </DialogTitle>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={() => setShowSendBackToAppDialog(false)}
            variant="contained"
            color="secondary"
            style={{ color: 'white' }}
          >
            No
          </Button>

          <div style={{ width: 24 }} />

          <Button
            onClick={sendOrderBackToApp}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
            disabled={unstashLoading}
          >
            {unstashLoading ? (
              <CircularProgress style={{ fill: '#222', color: 'white' }} size={24} />
            ) : (
              <span>Yes</span>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing instructions to self-inspect user */}
      <Dialog open={showInstructionsDialog} onClose={() => setShowInstructionsDialog(false)}>
        <DialogTitle style={{ textAlign: 'center' }}>Instructions</DialogTitle>
        <DialogContent
          dividers
          style={{
            // minWidth: 500,
            // minHeight: 400,
            borderTop: '0.8px solid #ddd',
            borderBottom: '0.8px solid #ddd',
            paddingTop: 20,
            // pointerEvents: disabled ? 'none' : 'auto',
            // opacity: disabled ? 0.5 : 1,
          }}
        >
          <ul className={classes.instructionsList}>
            <li>
              Answer as many questions as you can, and make sure to answer any questions marked with an asterisk (*).
            </li>
            <li>You can save your progress at any time by pressing the save button at the top of the page.</li>
            <li>
              Add as many images to questions/answers as needed by pressing the camera icon next to that
              question/answer. A red camera icon means that an image is required and one or more images have not been
              attached yet.
            </li>
            {/* <li>The form will automatically save when you go to the next step.</li> */}
            <li>
              Once you are done, submit your report on the review page to send the report to our QA team for final
              review .
            </li>
            <li>
              Form more help, please contact QA at <a href="tel:123-456-7890">123-456-7890</a> or{' '}
              <a href="mailto:">qa@jmi.com</a>
            </li>
          </ul>
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Button onClick={() => setShowInstructionsDialog(false)} variant="contained" className="blue-button">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        // autoHideDuration={7000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={showReturnToDashboardSnackbar}
        onClose={() => setShowReturnToDashboardSnackbar(false)}
      >
        <SnackbarContent
          className={cn(classes.returnToDashboardSnackbar)}
          aria-describedby="app-snackbar"
          message="You have unsaved changes on these forms... If you continue, your changes will be lost."
          action={
            <React.Fragment>
              <Button size="large" style={{ marginRight: 15 }} onClick={handleSnackbarContinue}>
                <span style={{ color: 'white', marginRight: 10 }}>Continue</span>
              </Button>
              <Button variant="contained" size="large" onClick={() => setShowReturnToDashboardSnackbar(false)}>
                Cancel
                <CloseIcon />
              </Button>
            </React.Fragment>
          }
        />
      </Snackbar>
      <PhotoUploadDialog open={photoUploadDialogVisible} setOpen={setPhotoUploadDialogVisible} />
    </div>
  ) : (
    <div>Data not found</div>
  );
});

const ContextWrapped = props => {
  const {
    state: {},
    dispatch,
  } = useContext(AppContext);

  return (
    <InspectorOrderReviewContextProvider>
      <DndProvider backend={Backend}>
        <InspectorOrderReview {...props} />
      </DndProvider>
    </InspectorOrderReviewContextProvider>
  );
};

InspectorOrderReview.propTypes = propTypes;

export default ContextWrapped;
